import { YEAR_MONTH_DAY } from '@/libs/filterDate'
import { UPGRADE_STATUS_OPTIONS } from './config'

export const parseDate = (date, format) => {
  if (!date) return undefined
  if (format) return format(date)
  return YEAR_MONTH_DAY(date)
}

export const parseStatus = status => {
  if (!status) return '-'
  return UPGRADE_STATUS_OPTIONS[status] || status
}

export const parseAge = age => {
  if (!age) return '-'
  return `${age} tahun`
}

export const parsePhone = phone => {
  if (!phone) return '-'
  return phone.replace(/^0?8/, '628')
}
